module.exports = __webpack_public_path__ + "media/images/pf_2024-d84532ef1d2fc91cb9995642ebbb0524.jpg";